// Grade levels are not stored as a teacher attribute anywhere in the backend,
// so we infer them from the class groups the teacher was observed with
// ("Grade 8A" / "8А сынып" → 8). Heuristic by design: only plausible school
// grades (1–12) are kept. Contiguous runs collapse to a range ("9–10"),
// otherwise grades are comma-listed ("7, 9"). Returns "" when nothing matches.
export const inferGradesFromObservations = (observations) => {
  const grades = new Set();
  (observations || []).forEach((o) => {
    const match = o?.group?.name?.match(/\d{1,2}/);
    const grade = match ? Number(match[0]) : null;
    if (grade >= 1 && grade <= 12) grades.add(grade);
  });
  if (!grades.size) return "";
  const sorted = [...grades].sort((a, b) => a - b);
  const contiguous = sorted.every((g, i) => i === 0 || g === sorted[i - 1] + 1);
  return contiguous && sorted.length > 1
    ? `${sorted[0]}–${sorted[sorted.length - 1]}`
    : sorted.join(", ");
};
